import styles from "./index.module.scss";
import Image from "next/image";
import { Layout } from "antd";
import { cdnHost, version } from "@/utils";
import { useTranslation } from "next-i18next";
import classNames from "classnames";
import dayjs from "dayjs";
const { Footer } = Layout;

export default function PublicFooter() {
  const { t, i18n } = useTranslation();
  console.log(t, i18n);
  return (
    <Footer
      className={classNames(styles["init-footer"])}
      style={{ backgroundImage: `url(${cdnHost}image/web-site/footer_bg.png?v=${version})` }}
    >
      <div className={styles.footer}>
        <div className="content">
          <div className="left">
            <Image
              className="logo"
              src={`${cdnHost}image/web-site/logo.png?v=${version}`}
              alt="logo"
              width={572}
              height={94}
            />

            <p className="left-text">
              <span>
                {t("ban-quan-suo-you")} Copyright © {dayjs().year()} UNIPUS, All Rights Reserved
              </span>

              <span style={{ display: "inline-flex", alignItems: "center" }}>
                <Image
                  className="left-text-icon"
                  src={`/img/footer.png?v=${version}`}
                  alt="logo"
                  width={20}
                  height={20}
                />
                <a
                  href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802045666"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("jing-gong-wang-an-bei", { num: "11010802045666" })}
                </a>
                &nbsp;&nbsp;&nbsp;
                <a
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("bei-an-hao", { icp: "18030989", num: "-46" })}
                </a>
              </span>
              <a
                href={`${cdnHost}image/web-site/human_resources_service_icense.jpeg?v=${version}`}
                target="_blank"
                rel="noreferrer"
              >
                {t("ren-li-zi-yuan-fu-wu-xu-ke-zheng")}
              </a>
            </p>
          </div>
          <div className="right">
            <Image
              className="code"
              src={`/img/wechat.png?v=${version}`}
              alt="logo"
              width={80}
              height={80}
              quality={100}
            />
            <p>{t("quan-qiu-yu-yan-fu-wu-ping-tai-gong-zhong-hao")}</p>
          </div>
        </div>
        {/* <div className="sub-content">
          <div className="logo">
            <Image
              className="title"
              src={`${cdnHost}image/web-site/logo-footer.png?v=3`}
              alt="logo"
              width={164}
              height={48}
            />
          </div>
          <p>
            <a
              className="bei-text"
              target="_blank"
              href="https://beian.miit.gov.cn"
              rel="noreferrer"
            >
              {t("bei-an-hao", { public: "：11010802020838", icp: "11010362", msg: "-71" })}
            </a>
            {
              // 只有中文才显示备案号
              i18n.language === "zh" && (
                <a
                  className="bei-text"
                  target="_blank"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802042733"
                  rel="noreferrer"
                >
                  <img
                    className="icon-beian"
                    src="//glsp-img.unipus.cn/image/icon-beian.png"
                    alt=""
                  />
                  京公网安备 11010802042733号
                </a>
              )
            }
          </p>

          <p>
            <span className="bei-text no-hover">
              {t("ban-quan", { msg: "Copyright © 2023 golingo.cn " })}
            </span>
          </p>
        </div> */}
      </div>
    </Footer>
  );
}
